import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import { Box } from "@mui/material";
import "./style.css";

const AutoComplete = forwardRef((props, ref, ...rest) => {
    const [inputValue, setInputValue] = useState(props.value);
    const [hasError, setHasError] = useState(false);
    const [options, setOptions] = useState();
    const [displayReadOnly, setDisplayReadOnly] = useState(true);

    useEffect(() => {
        //console.log("Plaintext :: ", inputValue);
        //console.log("Options Autocomplete :: ",props.options)
    }, [inputValue]);

    useImperativeHandle(ref, () => ({
        validate() {
            return isValidData();
        },
    }));

    const isValidData = () => {
        if (props.isRequired) {
            if (inputValue != "" && inputValue != undefined) {
                setHasError(false);
                return !false;
            } else {
                setHasError(true);
                return !true;
            }
        } else {
            setHasError(false);
            return !false;
        }
    };

    const handleChange = (event) => {
        let newValue = event.target.value;
        setInputValue(newValue);
        props.onChange(newValue);
        props.isRequired ? (newValue?.length > 0 ? setHasError(false) : setHasError(true)) : setHasError(false);
    };

    const handleSelect = (event, value) => {
        let newValue = value;
        if (newValue !== undefined) {
            //newValue = value;
            setInputValue(newValue);
            props.onChange(newValue);
            props.onBlur(newValue);
            props.isRequired ? (newValue?.length > 0 ? setHasError(false) : setHasError(true)) : setHasError(false);
        } else {
            setInputValue("");
            props.onChange("");
            props.onBlur("");
        }
        setDisplayReadOnly(true);
    };

    const validateInput = (event) => {
        let newValue = event.target.value;
        if (props.isRequired) {
            if (newValue === "" || newValue === undefined) {
                setHasError(true);
            }
            props.onBlur(newValue?.trim());
        } else {
            setHasError(false);
            props.onBlur(newValue?.trim());
        }
        setDisplayReadOnly(true);
    };

    const removeValidate = (event) => {
        setHasError(false);
    };

    const handleReadOnlyClick = () => {
        setDisplayReadOnly(false);
    };

    return (
        <div>
            {props.readOnly && (
                <Box
                    sx={{
                        background: "#d8d8d8",
                        width: "auto",
                        padding: "5px",
                        fontSize: "12px",
                        fontWeight: "400",
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: "black",
                        display: "inline",
                    }}>
                    {inputValue}
                </Box>
            )}
            {!props.readOnly && displayReadOnly && (
                <Box
                    onClick={handleReadOnlyClick}
                    onFocus={handleReadOnlyClick}
                    tabindex="0"
                    sx={{
                        padding: "12px 10px",
                        border: "1px solid #d6d6d6",
                        borderRadius: "4px",
                        display: "flex",
                        cursor: "auto",
                        height: "51.4px",
                        alignItems: "center",
                        position: "relative",
                        color: "#667085",
                    }}>
                    {inputValue && props.displayLabel && <Box className="autocomplete-label">{props.headingLabel}</Box>}
                    {inputValue && (
                        <Box
                            sx={{
                                background: "#d8d8d8",
                                width: "auto",
                                padding: "5px",
                                fontSize: "12px",
                                fontWeight: "400",
                                borderRadius: "5px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: "black",
                            }}>
                            {inputValue}
                        </Box>
                    )}
                    {!inputValue && (
                        <>
                            <Box
                                sx={{
                                    color: "#667085",
                                    fontSize: { xs: "17px", md: "12px" },
                                    fontWeight: "100",
                                    display: { xs: "none", md: "block" },
                                }}>
                                {props.placeholder}
                            </Box>
                            <Box
                                sx={{
                                    color: "#667085",
                                    fontSize: { xs: "17px", md: "12px" },
                                    fontWeight: "100",
                                    display: { xs: "block", md: "none" },
                                }}>
                                {props.headingLabel}
                            </Box>
                        </>
                    )}
                </Box>
            )}
            {!props.readOnly && !displayReadOnly && (
                <FormControl {...rest} sx={{}} fullWidth variant="outlined">
                    <Autocomplete
                        id={props.id}
                        value={inputValue}
                        readOnly={props.readOnly}
                        freeSolo
                        open={displayReadOnly ? false : true}
                        onChange={(event, value) => handleSelect(event, value)}
                        onBlur={validateInput}
                        autoFocus={true}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: "0px",
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "4px",
                                padding: "0",
                            },
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                border: props.readOnly ? "none" : "1px solid #d6d6d6",
                            },
                            "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                border: props.readOnly ? "none" : "1px solid #d6d6d6",
                            },
                            "& .MuiInputBase-input": {
                                padding: "16px 12px !important",
                                fontSize: ".8rem",
                            },
                        }}
                        options={props.options.map((option) => option)}
                        renderInput={(params) => (
                            <TextField
                                autoFocus={true}
                                {...params}
                                sx={{
                                    color: "#000",
                                    fontSize: "0.8rem",
                                    fontWeight: 400,
                                    "&::placeholder": {
                                        color: "red",
                                        fontSize: "0.75rem",
                                        opacity: 1, // otherwise firefox shows a lighter color
                                        input: {
                                            border: "none",
                                        },
                                    },
                                }}
                                placeholder={props.placeholder}
                                label={props.label}
                                required={props.isRequired}
                                variant="outlined"
                                onChange={handleChange}
                                onBlur={validateInput}
                                onFocus={removeValidate}
                            />
                        )}
                    />
                </FormControl>
            )}
        </div>
    );
});

export default AutoComplete;
